






















import {Vue, Component, Prop} from 'vue-property-decorator'
import {ReservationResponse, VehicleSlot} from '@/lib/kepler/interfaces'
import ServiceMesh from '@/lib/serviceMesh'
import Utils from '@/utils'
import Icon from '@/components/proxy/Icon.vue'

@Component({
  components: {
    Icon,
    Accordion: Utils.loadComponent('proxy/Accordion/Accordion'),
    AccordionContent: Utils.loadComponent('proxy/Accordion/AccordionContent'),
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Divider: Utils.loadComponent('proxy/Divider'),
    VehicleLocation: Utils.loadComponent('entities/vehicle/VehicleLocation'),
    Img: Utils.loadComponent('proxy/Image'),
  },
  name: 'VehicleLotAndDistance',
})
export default class VehicleLotAndDistance extends Vue {
  @Prop() private vehicleSlot!: VehicleSlot
  @Prop() private reservation?: ReservationResponse
  @Prop({type: Boolean, default: true}) private hasLocation?: boolean

  get vehicleTypeColor() {
    const key = `${this.vehicleSlot.reservation_type}${this.vehicleSlot.vehicle.category.type}`.toUpperCase()
    return {color: ServiceMesh.colors[key]}
  }

  get image() {
    return this.vehicleSlot.lot.picture.includes('404') ? false : this.vehicleSlot.lot.picture
  }

  get distanceString() {
    const d: number | null = this.vehicleSlot.distance
    if (d !== null) {
      if (d >= 1000) {
        return `${this.$t('common.circa')} ${Math.round((d / 1000) * 10) / 10}Km`
      } else {
        return `${this.$t('common.circa')} ${Math.floor(d)}m`
      }
    } else {
      // TODO: translate
      return false
    }
  }
}
